import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyAddressSearchLoupe } from '@root/entities/currency/ui/currency-address-search-loupe'
import { CurrencyInformationClipboard } from '@root/entities/currency/ui/currency-information/currency-information-clipboard'
import { CurrencyInformationSocial } from '@root/entities/currency/ui/currency-information/currency-information-social'
import { PairCashbackBadge } from '@root/entities/pair/ui/common/pair-cashback-badge'
import { PairTokenizedAgentBadge } from '@root/entities/pair/ui/common/pair-tokenized-agent-badge'
import { PairInformationAgeTime } from '@root/entities/pair/ui/pair-information/pair-information-age-time'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

export const PairExploreItemActions: React.FC<Props> = ({
  className,
  pair,
}) => {
  const [socials] = useAtom(pair.quote.socials)
  const [isCashBackMode] = useAtom(pair.isCashBackMode)
  const [isTokenizedAgent] = useAtom(pair.isTokenizedAgent)
  return (
    <Root className={className}>
      <PairInformationAgeTime pair={pair} />
      <Group>
        <Title ellipsis>{pair.quote.title}</Title>
        <CurrencyInformationClipboard currency={pair.quote} />
      </Group>
      <CurrencyAddressSearchLoupeAlt
        currencyAddress={pair.quote.address}
        symbol={pair.quote.ticker}
        size={14}
      />
      <CurrencyInformationSocial
        socials={socials}
        css={`
          border-radius: 4px;
          padding: 2px 4px;
          background: var(--backgroundA-2);
          margin-inline-start: 3px;
        `}
      />
      {isCashBackMode ? <PairCashbackBadge size={15} /> : undefined}
      {isTokenizedAgent ? <PairTokenizedAgentBadge size={15} /> : undefined}
    </Root>
  )
}

const Root = styled.div`
  color: var(--text-8);

  display: grid;
  grid-auto-flow: column;

  justify-items: start;
  align-items: center;
  justify-content: start;

  gap: 3px;

  > svg {
    cursor: pointer;
  }
`

const Group = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 2px;
`

const Title = styled(Typography)`
  color: var(--text-8);

  font-size: 11px;
  font-weight: 400;

  line-height: 16px;

  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const CurrencyAddressSearchLoupeAlt = styled(CurrencyAddressSearchLoupe)`
  height: 15px;
  margin-inline-start: -3px;
`
